export class ModelError {
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ModelError.attributeTypeMap;
    }
    constructor() {
    }
}
